import $ from 'jquery';

export default function userBtn() {
  
  function closeMenu($container) {
    const $btn = $container.find('.intranet-user__btn');
    const $menu = $container.find('.intranet-user__submenu');
    $btn.attr('aria-expanded', 'false');
    $menu.attr('hidden', true);
  }

  function openMenu($container) {
    const $btn = $container.find('.intranet-user__btn');
    const $menu = $container.find('.intranet-user__submenu');
    $btn.attr('aria-expanded', 'true');
    $menu.removeAttr('hidden');
    
    const $firstLink = $menu.find('a').first();
    if ($firstLink.length) {
      $firstLink.trigger('focus');
    }
  }

  function init() {
    // click fuori
    $(document).on("click", function (event) {
      $('.intranet-user').each(function () {
        const $container = $(this);
        if (!$(event.target).closest($container).length) {
          closeMenu($container);
        }
      });
    });

    // toggle bottone
    $('.intranet-user .intranet-user__btn').on('click', function (e) {
      const $container = $(this).closest('.intranet-user');
      const isOpen = $(this).attr('aria-expanded') === 'true';
      $('.intranet-notification').removeClass('open');
      $('.intranet-hamburger').removeClass('open');

      if (isOpen) {
        closeMenu($container);
        $(this).trigger('focus');
      } else {
        $('.intranet-user').each(function () {
          closeMenu($(this));
        });

        openMenu($container);
      }
    });

    // ESC per chiudere
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') {
        $('.intranet-user').each(function () {
          const $container = $(this);
          const $btn = $container.find('.intranet-user__btn');

          if ($btn.attr('aria-expanded') === 'true') {
            closeMenu($container);
            $btn.trigger('focus');
          }
        });
      }
    });
  }

  $(document).ready(function () {
    if ($('.intranet-user .intranet-user__btn').length > 0) {
      init();
    }
  });
}